export default {
  __name: 'index',
  props: {
  css: {
    type: Boolean,
    required: false,
    default: true,
  },
},
  setup(__props) {

const props = __props;



return { __sfc: true,props }
}

}